export default __webpack_public_path__ + "static/media/048-new zealand.deadb3d5.svg";